module.exports = __webpack_public_path__ + "img/electric-mining-drill-N.1eeb56bd.png";